var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TableContainer"}},[_c('div',[_c('Header',{attrs:{"table":"historyLogs"},on:{"search":_vm.search}})],1),_c('hr'),_c('div',{attrs:{"id":"table"}},[_c('HistoryLogList',{attrs:{"historyLogs":_vm.changedLogs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }